var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container about"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 justify-content-center"},[_c('h1',{staticClass:"title display-2"},[_vm._v(_vm._s(_vm.$t('title')))])]),_vm._v(" "),_vm._l((_vm.people),function(person){return _c('card',{key:person.name,attrs:{"person":person}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb80312","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = null
// module chunks = 